import {
  SET_CURRENT_COMPANY_BALANCE_SHEET,
  SET_CURRENT_COMPANY_BALANCE_SHEET_REPORT,
  SET_CURRENT_COMPANY_BALANCE_SHEET_REPORT_SUMMARY,
  SET_CURRENT_COMPANY_PROFIT_AND_LOSS,
  SET_CURRENT_RECONCILIATION_OF_VALUATION_METHODS_REPORT,
  SET_CURRENT_GOODWILL_REPORT,
  SET_STOCK_DEAL_SPLIT_REPORT,
  SET_ASSET_SALE_DEAL_SPLIT_REPORT,
  SET_OWNER_FINANCING_STOCK_SALE_REPORT,
  SET_ASSET_SALE_PROCEEDS_WORKSHEET,
  SET_CURRENT_COMPANY_MONTHLY_BALANCE_SHEET,
  SET_CURRENT_COMPANY_MONTHLY_PROFIT_AND_LOSS,
  SET_CURRENT_COMPANY_CASH_FLOW,
  SET_CURRENT_COMPANY_WORKING_CAPITAL,
} from "./mutations";

const initialState = {
  currentCompanyMonthlyBalanceSheet: null,
  currentCompanyBalanceSheet: null,
  currentCompanyMonthlyProfitAndLoss: null,
  currentCompanyProfitAndLoss: null,
  currentCompanyBalanceSheetReport: [],
  currentCompanyBalanceSheetReportSummary: null,
  currentReconciliationOfValuationMethodsReport: null,
  currentGoodwillReport: null,
  stockDealSplitReport: null,
  assetSaleDealSplitReport: null,
  ownerFinancingStockSaleReport: null,
  assetSaleProceedsWorksheet: null,
  currentCompanyCashFlow: null,
  currentCompanyWorkingCapital: null,
};

const financialsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_CURRENT_COMPANY_MONTHLY_BALANCE_SHEET:
      return { ...state, currentCompanyMonthlyBalanceSheet: payload };

    case SET_CURRENT_COMPANY_BALANCE_SHEET:
      return { ...state, currentCompanyBalanceSheet: payload };

    case SET_CURRENT_COMPANY_PROFIT_AND_LOSS:
      return { ...state, currentCompanyProfitAndLoss: payload };

    case SET_CURRENT_COMPANY_BALANCE_SHEET_REPORT:
      return { ...state, currentCompanyBalanceSheetReport: payload };

    case SET_CURRENT_COMPANY_BALANCE_SHEET_REPORT_SUMMARY:
      return { ...state, currentCompanyBalanceSheetReportSummary: payload };

    case SET_CURRENT_RECONCILIATION_OF_VALUATION_METHODS_REPORT:
      return {
        ...state,
        currentReconciliationOfValuationMethodsReport: payload,
      };

    case SET_CURRENT_GOODWILL_REPORT:
      return { ...state, currentGoodwillReport: payload };

    case SET_STOCK_DEAL_SPLIT_REPORT:
      return { ...state, stockDealSplitReport: payload };

    case SET_ASSET_SALE_DEAL_SPLIT_REPORT:
      return { ...state, assetSaleDealSplitReport: payload };

    case SET_OWNER_FINANCING_STOCK_SALE_REPORT:
      return { ...state, ownerFinancingStockSaleReport: payload };

    case SET_ASSET_SALE_PROCEEDS_WORKSHEET:
      return { ...state, assetSaleProceedsWorksheet: payload };

    case SET_CURRENT_COMPANY_MONTHLY_PROFIT_AND_LOSS:
      return { ...state, currentCompanyMonthlyProfitAndLoss: payload };

    case SET_CURRENT_COMPANY_WORKING_CAPITAL:
      return { ...state, currentCompanyWorkingCapital: payload };

    case SET_CURRENT_COMPANY_CASH_FLOW:
      return { ...state, currentCompanyCashFlow: payload };

    default:
      return state;
  }
};

export default financialsReducer;
